import { home } from './home';
import { faq } from './faq';
import { common } from './common';
import { path } from './path';
import { tenant } from './tenant';

export const Constants = {
    home,
    faq,
    common,
    path,
    tenant
};


// WEBPACK FOOTER //
// ./src/common/constants/index.js